import infoApi from './api/index'
import router from './router/index'
import settings from './settings'
import { Message } from 'element-ui'

const DEV = process.env.NODE_ENV === 'development'

const getCookie = key => {
  const res = document.cookie.match(`${key}=(.*?)($|;)`)
  if (res) {
    return res[1]
  }
  return undefined
}

function dtStrToTs (dtStr) {
  if (dtStr) {
    var dt = new Date(dtStr)
    dt.setHours(0, 0, 0, 0)
    return parseInt(dt / 1000)
  }
}

function tsToLocalDatetimeStr (ts) {
  // すでに文字列に変換されている場合その場でreturn
  if (typeof ts === 'string') {
    return ts
  } else if (!ts) {
    // 存在しない場合はその場でnullを返す
    return null
  }
  let tzoffset = new Date().getTimezoneOffset() * 60000
  let localISOTime = new Date(new Date(ts * 1000) - tzoffset)
    .toISOString()
    .slice(0, 10)

  return localISOTime
}
function handleBackPage(previous, pos) {
  this.$store.commit('update', {'loading': true})
  router.push({name: previous, query: router.history.current.query})
  // this.$store.commit('handle_page', previous)
  if (pos) {
    window.scrollTo(0, pos)
  } else {
    window.scrollTo(0, 0)
  }
  this.$store.commit('update', {'loading': false})
}

export default {
  dtStrToTs,
  tsToLocalDatetimeStr,
  handleBackPage
}



// WEBPACK FOOTER //
// ./src/utils.js